import * as types from './types';

const INITIAL_STATE = {
  report: null,
  loading: null,
  error: null,
  selectedHouseholds: [],
  resultsCounts: {
    NoResultsValue: 0,
    UnprintedValue: 0,
    PrintedValue: 0,
  },
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.VERIFICATION_RESULTS_LETTERS_GET_COUNTS:
      let resultsCounts = {
        NoResultsValue: payload.NoResultsValue,
        UnprintedValue: payload.UnprintedValue,
        PrintedValue: payload.PrintedValue,
      };

      return {
        ...state,
        resultsCounts: resultsCounts,
      };

    case types.VERIFICATION_RESULTS_LETTERS_GET_REPORT:
      return {
        ...state,
        report: payload,
      };

    case types.VERIFICATION_RESULTS_LETTERS_UPDATE_SELECTED:
      return { ...state, selectedHouseholds: payload };

    case types.VERIFICATION_RESULTS_LETTERS_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case types.VERIFICATION_RESULTS_LETTERS_ERROR:
      return {
        ...state,
        error: payload,
      };

    case types.VERIFICATION_RESULTS_LETTERS_CLEAR_REPORT:
      return {
        ...state,
        report: null,
        error: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/resultsletters/state/report/reducer.js